export const getErrorMessage = (error?: string | string[]) => (Array.isArray(error) ? error.join("\n") : error);
